import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
    connect() {
        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/cabinet/'+ usertoken,
            contentType: "application/json",
            async: false,
            success: function (data) {
                $('#userId').text(data.patient.ID);
            },
            error(error){
                console.debug(error);
            }
        })
    }
}